import { TokenConstants } from '../types';

const tokens: TokenConstants = {
  Popular: {
    Symbols: ['WBTC', 'DAI', 'USDC', 'BAL', 'AAVE', 'WETH'],
  },
  InitialSwapTokens: {
    input: '0xD102cE6A4dB07D247fcc28F366A623Df0938CA9E',
    output: '0x1073E53ac92F711761475Cd30fab157620AFdAb0',
  },
  Addresses: {
    nativeAsset: '0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE',
    wNativeAsset: '0xD102cE6A4dB07D247fcc28F366A623Df0938CA9E',
    WETH: '0xD102cE6A4dB07D247fcc28F366A623Df0938CA9E',
    BAL: '0x1073E53ac92F711761475Cd30fab157620AFdAb0',
  },
};

export default tokens;
